<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_no') || '纱线编号'"
            prop="yarnNo"
          >
            <el-input
              size="small"
              clearable
              v-model="formData.yarnNo"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_category_code') || '所属分类'"
            prop="categoryCode"
          >
            <dict-select
              filterable
              clearable
              size="small"
              v-model="formData.categoryCode"
              url="/master/masterCategory/classificationSelect"
              :disabled="disabledCode"
              :placeholder="
                $l('form_label_select_category_code') || '请选择所属分类'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_name') || '纱线名称'"
            prop="yarnName"
          >
            <el-input
              size="small"
              clearable
              v-model="formData.yarnName"
              :placeholder="$l('form_label_pe_yarn_name') || '请输入纱线名称'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_name_en') || '纱线名称英文'"
            prop="yarnNameEn"
          >
            <el-input
              size="small"
              clearable
              v-model="formData.yarnNameEn"
              :placeholder="
                $l('form_label_pe_yarn_name_en') || '请输入纱线名称英文'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_content') || '纱线成分中文'"
            prop="yarnContent"
          >
            <dict-select
              filterable
              clearable
              size="small"
              v-model="formData.yarnContent"
              url="/master/masterYarn/contentSelect"
              :placeholder="
                $l('form_label_pe_yarn_content') || '请选择纱线成分中文'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_content_en') || '纱线成分英文'"
            prop="yarnContentEn"
          >
            <el-input
              size="small"
              clearable
              v-model="formData.yarnContentEn"
              :placeholder="
                $l('form_label_pe_yarn_content_en') || '请输入纱线成分英文'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sup_code') || '供应商'"
            prop="supCode"
          >
            <dict-select
              filterable
              clearable
              size="small"
              v-model="formData.supCode"
              url="/master/masterAccessories/supplierSelect"
              :placeholder="$l('form_label_select_sup_name') || '请选择供应商'"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_count') || '支数'"
            prop="yarnCount"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.yarnCount"
              :step="0.01"
              :precision="2"
              :min="0"
              :max="9999999"
              controls-position="right"
              :placeholder="$l('form_label_pe_yarn_count') || '请输入支数'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_moq') || '起订量'"
            prop="moq"
            size="small"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.moq"
              :step="1"
              :precision="0"
              :min="0"
              :max="9999999"
              controls-position="right"
              :placeholder="$l('form_label_pe_moq') || '请输入起订量'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_kg_price') || '单价'"
            prop="kgPrice"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.kgPrice"
              :step="0.01"
              :precision="2"
              :min="0"
              controls-position="right"
              :placeholder="$l('form_label_pe_kg_price') || '请输入单价'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_yarn_unit') || '单位'"
            prop="yarnUnit"
          >
            <dict-select
              filterable
              clearable
              size="small"
              v-model="formData.yarnUnit"
              url="/master/masterYarn/yarnUnitSelect"
              :placeholder="$l('form_label_select_yarn_unit') || '请选择单位'"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_spinning_date') || '纺纱时间'"
            prop="spinningDate"
          >
            <el-date-picker
              type="date"
              v-model="formData.spinningDate"
              :placeholder="
                $l('form_label_select_spinning_date') || '请选择纺纱时间'
              "
              style="width: 100%"
              value-format="yyyy-MM-dd"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_status') || '有效状态'"
            prop="yarnStatus"
          >
            <br />
            <el-radio-group v-model="formData.yarnStatus">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_image_code') || '图片上传'"
            prop="imageCode"
            ><br />
            <el-upload
              class="contacts-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              :disabled="disabled"
            >
              <img
                v-if="formData.imageCode"
                :src="formData.imageCode"
                class="contactsEvent"
              />
              <i v-else class="el-icon-plus contactsEvent-uploader-icon"></i>
            </el-upload>
            <div class="mt-2">
              <span>{{
                $l('form_label_image_code_tip') ||
                  '只能上传jpg/png文件，建议文件大小不超过1.5M'
              }}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改?' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="back()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import util from '@/libs/util'

export default {
  props: {
    disabled: Boolean,
    yarnCode: String,
    categoryCode: String,
    pageType: String,
  },
  data() {
    return {
      backDialogVisible: false,
      disabledCode: true,
      formData: { categoryCode: '', imageCode: '', yarnStatus: 'Y' },
      rules: {
        categoryCode: [
          { required: true, message: '请选择所属分类名称', trigger: 'change' },
        ],
      },
      // 文件上传
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
    }
  },
  mounted() {
    this.getDate()
    this.setCode()
    this.setDisabled()
  },
  methods: {
    getDate() {
      if (!this.yarnCode) return
      this.$api
        .masterYarnDetailApi({
          yarnCode: this.yarnCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterYarnSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || res.msg,
              type: 'success',
            })
            this.$eventBus.$emit('yarnTableReload')
            this.back()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    setCode() {
      if (!this.categoryCode) return
      this.formData.categoryCode = this.categoryCode
    },
    setDisabled() {
      if (this.pageType == 'add') {
        this.disabledCode = false
      }
    },
    goBack() {
      if (this.disabled) {
        this.back()
        return
      }
      this.backDialogVisible = true
    },
    back() {
      this.backDialogVisible = false
      this.$router.go(-1)
    },
    //图片提交的方法
    beforeUpload(file) {
      this.$loading(this.options)
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1.5
      if (!isImg) {
        this.$message.warning(
          this.$l('INDEX.tips_image_type') || '上传图片只能是 JPG或PNG 格式!'
        )
      }
      if (!isLt2M) {
        this.$message.warning(
          this.$l('INDEX.tips_image_size') || '上传图片大小不能超过 1.5MB!'
        )
      }
      if (!isImg || !isLt2M) {
        this.$loading(this.options).close()
      }
      return isImg && isLt2M
    },
    handleSuccess(res) {
      if (res.status === 200) {
        this.formData.imageCode = res.body.url
        // 名片OCR
        // this.businessCardUrl(this.formData.contactNameCardUrl1)
        this.$loading(this.options).close()
      }
    },
  },
}
</script>
<!-- 图片文件的格式 -->
<style>
.contacts-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.contacts-uploader .el-upload:hover {
  border-color: #409eff;
}
.contactsEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.contactsEvent {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
